/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';
import PollingCircleFastForward from 'app/components/commons/PollingCircleFastForward';

type Props = {
  children: any,
  displayTimer: boolean,
  pollTimestamp: number,
};

const Title = glamorous.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.color.primary,
  boxShadow: '0 0 2px 2px #888',
  color: 'white',
  display: 'flex',
  fontSize: theme.fontSize.medium,
  fontWeight: theme.fontWeight.demiBold,
  ...padding(theme.spacing.tiny, theme.grid.gutter),
  position: 'relative',
  textTransform: 'uppercase',
  zIndex: 1,
}));

const PollingCircleContainer = glamorous.div(
  {
    display: 'flex',
    marginLeft: 'auto',
  },
  ({ theme }) => ({
    color: theme.color.white,
  }),
);

const Text = glamorous.span({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});

function ChallengeTitleMobile({ children, displayTimer, pollTimestamp }: Props) {
  return (
    <Title>
      <Text>{children}</Text>
      {displayTimer && (
        <PollingCircleContainer>
          <PollingCircleFastForward pollTimestamp={pollTimestamp} />
        </PollingCircleContainer>
      )}
    </Title>
  );
}

export default ChallengeTitleMobile;
